export const linkToCompleteAccountType = () => "/complete/account-type";
